import { render, staticRenderFns } from "./Arrivals.vue?vue&type=template&id=3b72c3be&scoped=true"
import script from "./Arrivals.vue?vue&type=script&lang=js"
export * from "./Arrivals.vue?vue&type=script&lang=js"
import style0 from "./Arrivals.vue?vue&type=style&index=0&id=3b72c3be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b72c3be",
  null
  
)

export default component.exports